import { render, staticRenderFns } from "./Awnser.vue?vue&type=template&id=2c055991&"
import script from "./Awnser.vue?vue&type=script&lang=js&"
export * from "./Awnser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports